import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import thunk from 'redux-thunk';
import { createStore, compose, applyMiddleware } from 'redux';

import eventListingReducer from './eventListingReducer.mjs';
import EventList from './EventList';

const rootContainer = document.getElementById('event-listing-app');

if (rootContainer) {
    
    const root = createRoot(rootContainer);
    
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: "Event Listing"
    }) : compose;

    const pageSize = JSON.parse(rootContainer.dataset.pageSize);
    let size = 6;
    if(pageSize != 0) {
      size = pageSize;
    }

    let store = createStore(
      eventListingReducer,
      {
        loading: false,
        error: false,
        page: 0,
        size: size,
        language: rootContainer.dataset.lang,
        title: rootContainer.dataset.title,
        load: rootContainer.dataset.load,
        results: {
            eventsTotal: 0,
            eventHits: [],
            },
      },
      composeEnhancers(applyMiddleware(thunk))
    );


    root.render(
        <div>
            <Provider store={store}>
                <EventList sectionid="tapahtumat"/>
            </Provider>
        </div>
    );
}
